module.exports = __webpack_public_path__ + "img/loading.7b4225f2.svg";